import { MonetizableEnum } from '@ria-client/segment/enums';
import { CircleHelp } from 'lucide-react';
import { DisclosureTooltip } from '../DisclosureTooltip/DisclosureTooltip';
import { BASE_RIA_TOOLTIP_CONTENT, FIDELITY_TOOLTIP_CONTENT } from './constants';

export interface RiaDisclaimerProps {
  isFidelityOffer?: boolean;
  monetizable?: MonetizableEnum;
  riaDisclaimerText: string;
  isReview?: boolean;
  hideToolTip?: boolean;
  tooltipMargin?: number;
}

export function RiaDisclaimer({
  isFidelityOffer = false,
  monetizable,
  riaDisclaimerText,
  hideToolTip = false,
  isReview = false,
  tooltipMargin,
}: RiaDisclaimerProps) {
  const isMonetizing = monetizable === MonetizableEnum.yesAssumed;
  const showToolTip = isMonetizing && !hideToolTip;

  return (
    <div className={`flex flex-wrap gap-2${isReview ? ' w-full' : ''}`}>
      {isMonetizing ? (
        <div className="flex max-w-fit items-center rounded bg-[var(--content-yellow-lightest)] p-2">
          <span className="typography-text-small font-medium">AD</span>
        </div>
      ) : null}
      <div
        className={`flex items-center justify-between rounded bg-[var(--content-yellow-lightest)] p-2${
          isReview ? ' inline-flex sm:grow' : ''
        }`}
      >
        <span className="typography-text-small">{riaDisclaimerText}</span>
        {showToolTip ? (
          <DisclosureTooltip
            className="max-w-[400px]"
            trigger={
              <button
                aria-label="Toggle Ria offer disclaimer"
                className="inline-flex shrink-0 cursor-pointer bg-transparent p-0 text-muted-foreground"
                style={{ marginLeft: `${(tooltipMargin ?? 1) * 8}px` }}
                type="button"
              >
                <CircleHelp aria-hidden size={24} />
              </button>
            }
          >
            {isFidelityOffer ? FIDELITY_TOOLTIP_CONTENT : BASE_RIA_TOOLTIP_CONTENT}
          </DisclosureTooltip>
        ) : null}
      </div>
    </div>
  );
}
